import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "./assets/css/bootstrap.min.css";
import "./assets/css/album.css";
import "./assets/css/master.css";
import "./assets/css/all.min.css";
import "./assets/css/fontawesome-all.css";
import "./assets/css/compiled-4.7.5.min.css";
import "./assets/css/profile.css";
import "./assets/css/hscroll.css";
import "./assets/css/login.css";

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();
